import { render, staticRenderFns } from "./PurchaseInformationCard.vue?vue&type=template&id=34d66fb8&"
import script from "./PurchaseInformationCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports